import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Injectable, Injector, inject } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  appLang: any;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    // private modalService: NgbModal,
    // ,
    private readonly injector: Injector
  ) { }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const translateService = this.injector.get(TranslateService);
        if (error) {
          if (error.status === 400) {
            if (error.error.errors) {
              for (const err of error.error.errors) {
                console.log(err);

                // this.toastr.error(err, error.error.statusCode);
              }
              throw error.error;
            } else {
              this.toastr.error(
                error.error.message,
                error.error.statusCode
              );
            }
          }
          if (error.status === 401) {
            //localStorage.clear();
            //this.router.navigateByUrl('/login');
          }

          if (error.status === 500) {
            console.log(error.error);

          }
          if (error.status === 402) {
            console.log(error.error);
            this.toastr.error(error.error.message);
          }

          if (error.status === 515) {
            console.log(error.error);
            this.toastr.error(error.error.message);
          }


          if (error.status == 0) {
            // if u want to catch the error and pass to server-error page
            // const navigationExtras: NavigationExtras = { state: { error: error.error } }
            // this.router.navigateByUrl('/server-error', navigationExtras);
            //  this.router.navigateByUrl('/server-error');
            // this.toastr.error( translateService.instant('somethingWentWrongTryAgainLater'));
          }

        }
        return throwError(error);
      })
    );
  }

}
